import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      navbar: {
        home: "Home",
        about: "About",
        services: "Services",
        personalLoan: "Personal Loan",
        goldLoan: "Gold Loan",
        mortgageLoan: "Mortgage Loan",
        loanAgainstDeposit: "Loan Against Deposit",
        businessLoan: "Business Loan",
        agricultureLoan: "Agriculture Allied Loan",
        vehicleLoan: "Vehicle Loan",
        depositSchemes: "Deposit Schemes",
        members: "Directors",
        news: "News",
        branches: "Branches",
        gallery: "Gallery",
        careers: "Careers",
        contact: "Contact",
        applyLoan: "Apply Loan",
        applyLoanNow: "Apply Loan Now",
        languageTitle: "Language",
        languageSelect: "Language / Select"
      },
      footer: {
        description: "Empowering rural communities with trusted financial solutions since 1998. Your growth is our priority.",
        quickLinks: "Quick Links",
        ourServices: "Our Services",
        allRightsReserved: "All Rights Reserved.",
        designedBy: "Designed by",
        newsUpdates: "News & Updates",
        photoGallery: "Photo Gallery",
        fixedDeposit: "Fixed Deposit",
        recurringDeposit: "Recurring Deposit",
        savingsAccount: "Savings Account",
        seniorCitizenScheme: "Senior Citizen Scheme",
        contactInfo: "Contact Info",
        legalPolicies: "Legal & Policies",
        privacyPolicy: "Privacy Policy",
        termsConditions: "Terms & Conditions",
        designDevelopedBy: "Design & Developed By",
        address: "Sangram Bhawan, Karad Tasgaon Road, Palus, Tal.Palus, Dist.Sangli."
      },
      aboutPage: {
        aboutUs: "About Us",
        aboutSubtitle: "Empowering rural dreams through professional cooperative banking since 1998.",
        ourStoryBadge: "Our Story",
        titleSangram: "Sangram",
        titlePatsanstha: "Patsanstha",
        subtitle: "From a Small Seed to a Mighty Banyan: We are dedicated to uplifting our members and rural communities through trust and cooperative strength.",
        para1: "In 1998, Sangram Patsanstha was born from a simple yet powerful idea: to provide a helping hand to the rural heart of our nation. Our founders envisioned a financial institution that wasn't just about numbers, but about the people—the farmers, the small business owners, and the families striving for a better tomorrow.",
        para2: "Today, we stand as a beacon of financial hope, having weathered economic storms and embraced the digital revolution, all while keeping our core values of cooperation and transparency at the forefront of everything we do.",
        exploreBranches: "Explore Our Branches",
        foundersMessageTitle: "From the Founder's Desk",
        inspiration: "Our Inspiration",
        founderName: "Late. Vithhalrao (Bapuso) Babanrao Yesugade",
        founderRole: "Founder Sangram Udyog Samuh, Palus",
        founderMessage: "We believed that every farmer, small trader, and family in our region deserved access to honest, transparent, and cooperative banking. Today, seeing that dream flourish in the hearts of thousands of members fills us with immense pride. Our goal was never just to build a patsanstha, but to build an ecosystem of trust, growth, and security for the rural community.",
        founderQuote: "Empowering the common man is the truest form of cooperative strength.",
        founderSub: "Bapusaheb Yesugade Sangram Gramin Bigar Sheti Sahkari Patsanstha Maryadit, Palus.",
        chairmansCornerTitle: "From the Chairman's Desk",
        visionRole: "Our Visionary Leader",
        chairmanName: "Shri. Nilesh Vithhalrao Yesugade",
        chairmanRole: "Chairman, Bapusaheb Yesugade Sangram Udyog Samuh, Palus.",
        chairmanMessage: "Our goal is to empower every member with financial stability and modern banking solutions. At Sangram Patsanstha, we don't just provide banking; we build lasting relationships and foster community growth through mutual trust and innovative financial services.",
        chairmanQuote: "True progress is when the community grows together.",
        chairmanCornerLabel: "A Message to Our Members",
        corePurposeBadge: "Our Core Purpose",
        corePurposeTitle: "Shaping a Better Financial Future",
        corePurposeDesc: "We are driven by a singular focus: to uplift our members and rural communities through cooperative financial services built on trust, innovation, and integrity.",
        missionBadge: "Our Mission",
        missionTitle: "Fostering Rural Prosperity",
        missionDesc: "To provide high-quality, transparent, and accessible financial services to the rural community, fostering economic independence and sustainable growth through cooperative values.",
        visionBadge: "Our Vision",
        visionTitle: "Empowering Every Member",
        visionDesc: "To be the most trusted and innovative cooperative bank, recognized for our commitment to rural development and for creating lasting financial prosperity for our members.",
        pillarsBadge: "Our Pillars",
        pillarsTitle: "The Principles That Guide Us",
        pillarsDesc: "Our core values form the foundation of our institution, ensuring we remain committed to transparency, local empowerment, and excellence in all operations.",
        integrityTitle: "Integrity",
        integrityDesc: "We maintain the highest standards of professional ethics and transparency in all our dealings.",
        communityTitle: "Community",
        communityDesc: "Our focus is always on the welfare and development of our local community and members.",
        excellenceTitle: "Excellence",
        excellenceDesc: "We strive to provide superior financial services through innovation and customer-centricity.",
        trustTitle: "Trust",
        impactBadge: "Our Impact",
        impactTitle: "Driving Prosperity Through Numbers",
        impactDesc: "Every digit represents a life empowered and a dream supported by our cooperative mission.",
        awardsBadge: "Honors & Achievements",
        awardsTitle: "Recognition of Excellence",
        awardsSubtitle: "Celebrating our commitment, milestones, and prestigious recognition in cooperative banking.",
        clickToEnlarge: "Click to view full image",
        closeView: "Close View"
      },
      homePage: {
        happyMembers: "Happy Members",
        totalDeposits: "Total Deposits",
        loansDisbursed: "Loans Disbursed",
        yearsOfTrust: "Years of Trust",
        learnMore: "Learn More",
        applyNow: "Apply Now",
        aboutBadge: "About Sangram Patsanstha",
        aboutTitle: "Empowering Rural Communities Since 1998",
        aboutPara1: "Sangram Patsanstha was founded with a vision to provide accessible and affordable financial services to those who need it most. We believe that true progress starts at the grassroots level.",
        aboutPara2: "Over the decades, we have evolved from a small cooperative into a leading financial institution, serving over 50,000 members with unwavering trust and professional integrity.",
        readOurStory: "Read Our Story",
        planFinancesTitle: "Plan Your Finances",
        planFinancesDesc: "Use our smart calculators to estimate your EMI payments or calculate your Fixed Deposit maturity value effortlessly.",
        ctaTitle: "Building Financial Strength for Every Rural Family",
        ctaDesc: "Join thousands of satisfied members and start your journey towards financial prosperity with Sangram Patsanstha.",
        contactUsBtn: "Contact Us",
        trustInNumbers: "Trust in Numbers",
        trustInNumbersDesc: "Our growth is a testament to the trust placed in us by thousands of families and businesses across the region.",
        happyCustomers: "Happy Customers",
        loansDistributed: "Loans Distributed",
        investment: "Investment",
        villagesConnected: "Villages Connected",
        yearsOfService: "Years of Service",
        heroTitle: "Empowering Rural Growth with Trusted Banking",
        heroSubtitle: "Secure savings, easy loans, and community-focused financial services tailored for your prosperity and a stronger tomorrow.",
        heroButtonText: "Apply for Loan",
        servicesBadge: "Our Loan Services",
        servicesTitle: "Flexible Financial Solutions for Every Need",
        viewAllServices: "View All Services",
        customLoanTitle: "Need a Customized Loan?",
        customLoanDesc: "Talk to our experts today for a tailored financial solution that fits your requirements perfectly.",
        contactExpert: "Contact Expert",
        learnMoreLink: "Learn More",
        personalLoanTitle: "Personal Loan",
        personalLoanDesc: "Quick financial assistance for your personal needs, medical emergencies, or family celebrations with minimal documentation.",
        goldLoanTitle: "Gold Loan",
        goldLoanDesc: "Get instant cash against your gold ornaments with competitive interest rates and secure storage in our certified vaults.",
        mortgageLoanTitle: "Mortgage Loan",
        mortgageLoanDesc: "Unlock the value of your property to fulfill your dreams or expand your business with long-term flexible repayment options.",
        businessLoanTitle: "Business Loan",
        businessLoanDesc: "Specially designed financial solutions to help small and medium businesses grow, manage cash flow, and upgrade equipment.",
        agricultureLoanTitle: "Agriculture Allied Loan",
        agricultureLoanDesc: "Supporting our farmers with low-interest loans for seeds, fertilizers, machinery, and irrigation to boost agricultural productivity.",
        vehicleLoanTitle: "Vehicle Loan",
        vehicleLoanDesc: "Drive your dream vehicle home with our easy, quick, and hassle-free vehicle financing options.",
        depositBadge: "Invest for Future",
        depositTitle: "High-Growth Deposit Schemes",
        depositDesc: "Secure your hard-earned money with our attractive deposit schemes that offer safety, liquidity, and high returns.",
        knowMoreBtn: "Know More",
        notSureScheme: "Not sure which scheme to choose?",
        compareRatesDesc: "Compare our rates and calculate your returns instantly.",
        interestRatesBtn: "Interest Rates",
        emiCalculatorBtn: "EMI Calculator",
        whyChooseUsBadge: "Why Sangram Patsanstha",
        whyChooseUsTitle: "Your Trusted Partner for Financial Success",
        whyChooseUsDesc: "We are more than just a bank. We are a community-driven institution dedicated to providing the best financial tools and support to help you achieve your dreams.",
        rbiCompliantTitle: "RBI Compliant",
        rbiCompliantSub: "Secure & Regulated",
        secureBankingTitle: "Secure Banking",
        secureBankingDesc: "Your money is protected with multi-layer security and state-of-the-art encryption.",
        fastApprovalsTitle: "Fast Approvals",
        fastApprovalsDesc: "Get your loans approved within 24-48 hours with minimal paperwork.",
        lowInterestTitle: "Low Interest",
        lowInterestDesc: "Enjoy competitive interest rates on loans tailored for rural development.",
        transparencyTitle: "Transparency",
        transparencyDesc: "No hidden charges or complex terms. We believe in 100% honest banking."
      },
      loanDetails: {
        loanOverview: "Loan Overview",
        keyBenefits: "Key Benefits",
        requirementsAndDocs: "Requirements & Documentation",
        eligibility: "Eligibility",
        documentsRequired: "Documents Required",
        loanFileOrder: "Loan File Documents Order",
        guarantorDocs: "Guarantor Documents Required",
        mediumTermDocs: "Documents Required for Medium Term Loan",
        siteInspectionDocs: "Branch Officer Site Inspection Report",
        faqs: "Frequently Asked Questions",
        interestRate: "Interest Rate",
        startingFrom: "Starting from per annum",
        applyButton: "Apply for Loan",
        terms: "*Terms and conditions apply",
        needAssistance: "Need Assistance?",
        fastApproval: "Fast Approval",
        fastApprovalTime: "24-48 Hours",
        talkExperts: "Talk to our experts"
      },
      membersPage: {
        pageTitle: "Our Directors",
        pageSubtitle: "From FY 2023-24 to 2028-29",
        leadership: "Leadership",
        boardOfDirectors: "Board of Directors",
        noMembers: "No board members found.",
        joinTeamTitle: "Want to Join Our Team?",
        joinTeamDesc: "We are always looking for passionate individuals who want to make a difference in the rural financial sector.",
        viewCareers: "View Career Opportunities",
        yearsOfExperience: "Years of",
        experience: "Experience",
        tenure: "From FY 2023-24 to 2028-29"
      },
      depositPage: {
        pageTitle: "Deposit Schemes",
        pageSubtitle: "Secure your future with our range of high-interest investment plans tailored for every need.",
        annualInterest: "Interest",
        planOverview: "Plan Overview",
        schemeDetails: "Scheme Details",
        noSchemesTitle: "No deposit schemes available currently",
        noSchemesDesc: "Please check back later for our updated investment plans.",
        fixedDeposit: "Fixed Deposit",
        recurringDeposit: "Recurring Deposit",
        savingsAccount: "Savings Account",
        seniorCitizenScheme: "Senior Citizen Scheme",
        year: "Year",
        years: "Years",
        interestRateTableTitle: "Current Deposit Interest Rates (w.e.f. 02/05/2026)",
        tableColSrNo: "Sr. No.",
        tableColDepositType: "Type of Deposit",
        tableColDuration: "Duration",
        tableColInterestRate: "Interest Rate (w.e.f. 02/05/2026)",
        savingDeposit: "Saving Deposit",
        termDeposit: "Term Deposit",
        silverJubileeDeposit: "Bapusaheb Yesugade Silver Jubilee Deposit",
        sangramDeposit: "Sangram Deposit",
        doubleMoneyDeposit: "Double Money Deposit",
        oneAndHalfMoneyDeposit: "1.5 Times Money Deposit",
        durDays46To180: "46 Days to 180 Days",
        durDays181To365: "181 Days to 365 Days",
        durMonths15: "1 Year 3 Months (15 Months)",
        durMonths13Monthly: "1 Year 1 Month (Monthly Interest Facility)",
        durSeniorCitizenMonthly: "Senior Citizen (Monthly Interest)",
        durMonths90: "90 Months",
        durMonths67: "67 Months"
      },
      newsPage: {
        pageTitle: "News & Updates",
        pageSubtitle: "Stay updated with the latest bank announcements, financial tips, and community events.",
        searchPlaceholder: "Search articles...",
        noNewsFound: "No news found matching your criteria.",
        readFullStory: "Read Full Story",
        backToNews: "Back to News",
        byAuthor: "By",
        shareStory: "Share this story",
        tags: "Tags:"
      },
      galleryPage: {
        pageTitle: "Photo Gallery",
        pageSubtitle: "Capturing moments of growth, community service, and our journey through the years.",
        noImagesFound: "No images found in this category.",
        all: "All",
        eventPhotos: "Event Photos",
        officeImages: "Office Images",
        programs: "Programs",
        socialActivity: "Social Activity"
      },
      careersPage: {
        pageTitle: "Careers",
        pageSubtitle: "Join our mission to empower communities through trust and financial innovation.",
        ourCulture: "Our Culture",
        whyStartCareer: "Why Start Your Career at",
        whyStartCareerDesc: "We don't just offer jobs; we offer a path to professional growth and community impact.",
        growthMindset: "Growth Mindset",
        growthMindsetDesc: "We invest in your learning and provide clear career progression paths.",
        collaborativeTeam: "Collaborative Team",
        collaborativeTeamDesc: "Work with passionate professionals in a supportive and inclusive environment.",
        industryRecognition: "Industry Recognition",
        industryRecognitionDesc: "Be part of a trusted cooperative bank with 28+ years of excellence.",
        currentOpenings: "Current Openings",
        activePositions: "Active Positions",
        noOpenPositions: "No open positions currently",
        checkBackLater: "Please check back later or submit a general inquiry below.",
        didntFindTitle: "Didn't find what you're looking for?",
        didntFindDesc: "Send us your CV anyway! We're always looking for talented individuals to join our growing family.",
        dropCV: "Drop Your CV",
        applyNow: "Apply Now",
        fullTime: "Full Time",
        vacancies: "Vacancies"
      },
      jobApplicationPage: {
        pageHeaderTitle: "Apply for Career",
        pageHeaderSubtitle: "Apply for the position of {{position}} at Sangram Patsanstha.",
        careerOpportunity: "Career Opportunity",
        takeNextStep: "Take the Next Step in Your",
        professionalJourney: "Professional Journey",
        whyJoinDesc: "We are looking for individuals who are passionate about cooperative banking and community service. Join us and make a difference.",
        equalOpportunity: "Equal Opportunity",
        equalOpportunityDesc: "We celebrate diversity and are committed to creating an inclusive environment.",
        reviewTimeline: "Review Timeline",
        reviewTimelineDesc: "Our HR team typically reviews applications within 7-10 working days.",
        applicationTips: "Application Tips",
        applicationTipsDesc: "Make sure your contact information is correct and your resume is updated.",
        secureApplication: "Secure Application",
        gdprCompliant: "GDPR & Data Privacy Compliant",
        applicationForm: "Application Form",
        fullName: "Full Name",
        fullNamePlaceholder: "Enter your Full Name",
        email: "Email Address",
        emailPlaceholder: "email@example.com",
        contactNumber: "Contact Number",
        cityLocation: "City / Location",
        cityPlaceholder: "e.g. Satara",
        applyingPosition: "Applying For Position",
        yearsExperience: "Years of Experience",
        selectExperience: "Select Experience",
        fresher: "Fresher (0 Years)",
        exp1_2: "1-2 Years",
        exp3_5: "3-5 Years",
        exp5_10: "5-10 Years",
        exp10_plus: "10+ Years",
        uploadResume: "Upload Resume (PDF only - Max 1MB)",
        readyToUpload: "Ready to upload",
        dropResume: "Drop your resume here or click to browse",
        supportPdfOnly: "Support: PDF only (Max 1MB)",
        submitApplication: "Submit Application",
        successTitle: "Application Received!",
        successText: "Thank you for your interest. Our HR team will review your profile and contact you if shortlisted.",
        errorTitle: "Submission Failed",
        errorText: "We encountered an error while processing your application. Please try again later.",
        validationTitle: "Error",
        validationText: "Resume size should not exceed 1MB"
      },
      contactPage: {
        pageHeaderTitle: "Contact Us",
        pageHeaderSubtitle: "Have questions or need assistance? Our team is here to help you.",
        callUs: "Call Us",
        emailUs: "Email Us",
        visitUs: "Visit Us",
        availableHrs: "Available Mon-Sat, 10:30 AM - 6 PM",
        weRespond: "We respond within 24 hours",
        addressDetails: "Karad Tasgaon Road, Palus, Tal.Palus, Dist.Sangli.",
        addressText: "Sangram Bhawan",
        sendMessage: "Send Us a Message",
        fullName: "Full Name",
        fullNamePlaceholder: "Enter your Full Name",
        email: "Email Address",
        emailPlaceholder: "email@example.com",
        phoneNumber: "Phone Number",
        inquiryType: "Inquiry Type",
        selectOption: "Select Options",
        generalInquiry: "General Inquiry",
        personalLoan: "Personal Loan",
        goldLoan: "Gold Loan",
        businessLoan: "Business Loan",
        fixedDeposit: "Fixed Deposit",
        socialActivity: "Social Activity",
        yourMessage: "Your Message",
        messagePlaceholder: "How can we help you today?",
        sendMessageBtn: "Send Message",
        sendingMessageBtn: "Sending Message...",
        successTitle: "Success!",
        successText: "Your message has been sent successfully. Our team will contact you soon.",
        errorTitle: "Submission Error",
        errorText: "Failed to send message. Please try again later."
      },
      loanApplicationPage: {
        pageHeaderTitle: "Apply for Loan",
        pageHeaderSubtitle: "Empowering your financial journey with easy and accessible loan solutions.",
        quickApplication: "Quick Application",
        turnDreamsTitle: "Turn Your Dreams",
        into: "Into ",
        reality: "Reality",
        today: " Today",
        intoRealitySubtitle: "Take the first step towards your financial goals. Whether it's a new home, expanding your business, or personal milestones, we are here to support you.",
        trustedMembers: "Trusted by 50K+ Members",
        safeProcessing: "Safe and transparent processing",
        whyChooseTitle: "Why Choose Our Loan?",
        whyChooseItem1: "Competitive interest rates in the market",
        whyChooseItem2: "Minimal documentation and paperless process",
        whyChooseItem3: "Flexible repayment options (EMIs)",
        whyChooseItem4: "No hidden charges or processing delays",
        whyChooseItem5: "Quick and hassle-free disbursement within 24 hours",
        whyChooseItem6: "Trusted cooperative support with expert financial advice",
        loanApplicationForm: "Loan Application Form",
        accurateInfoDesc: "Please provide accurate information for faster processing.",
        fullName: "Full Name",
        fullNamePlaceholder: "Enter your Full Name",
        email: "Email Address",
        emailPlaceholder: "email@example.com",
        contactNumber: "Contact Number",
        phonePlaceholder: "+91 98765 43210",
        cityLocation: "City / Location",
        cityPlaceholder: "e.g. Pune",
        loanType: "Loan Type",
        requiredAmount: "Required Amount (₹)",
        requiredAmountPlaceholder: "e.g. 500000",
        applyNow: "Apply Now",
        needHelp: "Need help? Call our support:",
        successTitle: "Application Submitted!",
        successText: "Thank you for choosing Sangram Patsanstha. Our loan officer will contact you within 24 hours.",
        errorTitle: "Submission Failed",
        errorText: "Something went wrong. Please try again or visit our nearest branch."
      },
      privacyPolicyPage: {
        pageTitle: "Privacy Policy",
        pageSubtitle: "We value your trust. Learn how we safeguard and manage your personal and financial information.",
        trustedSecurityTitle: "Trusted Banking Security",
        trustedSecurityDesc: "We constantly upgrade our firewalls and internal compliance guidelines to guarantee that your data is safe and handled in line with the national regulatory standards.",
        lastUpdated: "Last updated: May 2026",
        questionsTitle: "Have questions about our privacy practices?",
        questionsDesc: "If you have questions, concerns, or requests regarding this Privacy Policy, please write to our Data Protection Officer at:",
        email: "Email",
        address: "Address",
        sections: {
          commitment: {
            title: "Our Privacy Commitment",
            desc: "At Sangram Patsanstha, your privacy is our highest priority. We are dedicated to guarding your personal and financial information through cutting-edge security systems and rigid operational protocols."
          },
          collect: {
            title: "Information We Collect",
            desc: "We collect personal identification details (name, PAN, Aadhaar, address), contact information, financial transactions history, employment details, and digital footprint data when you use our online portal."
          },
          protect: {
            title: "How We Protect Your Data",
            desc: "All sensitive transactional data is secured using advanced 256-bit SSL encryption. We house our data in bank-grade, secure cloud servers and strictly restrict staff access on a need-to-know basis."
          },
          sharing: {
            title: "Information Sharing Policy",
            desc: "We never sell your personal information. We only share data with authorized credit bureaus, government agencies, and partner institutions when legally required or essential to complete your transactions."
          },
          rights: {
            title: "Your Data Rights",
            desc: "You have complete rights to review, update, or correct your personal data stored with us. You can request a summary of your data or opt out of specific promotional notifications at any time."
          },
          cookies: {
            title: "Cookies & Analytics",
            desc: "We use cookies to analyze web traffic, remember your preferences, and present a custom banking experience. You can manage cookie preferences directly from your web browser settings."
          }
        }
      },
      termsConditionsPage: {
        pageTitle: "Terms & Conditions",
        pageSubtitle: "Please review the legal rules, guidelines, and terms governing your use of our banking services.",
        officialAgreementTitle: "Official Service Agreement",
        officialAgreementDesc: "By accessing our website and utilizing any of our deposit schemes, loan inquiry portals, or online platforms, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions.",
        version: "Version 2.4 (Active)",
        governingLawTitle: "Governing Law & Dispute Resolution",
        governingLawDesc: "These Terms and Conditions shall be governed by, and construed in accordance with, the laws of the Republic of India. Any disputes arising in connection with these terms shall be subject to the exclusive jurisdiction of the competent courts in Pune, Maharashtra.",
        terms: {
          membership: {
            title: "1. Account & Membership Terms",
            desc: "Membership is subject to verification and approval by the Board of Directors. All information provided during registration must be authentic. Any falsification of information can result in automatic termination of account and legal actions."
          },
          security: {
            title: "2. Online Banking & Security",
            desc: "Users are completely responsible for safeguarding their login credentials, passwords, and mobile OTPs. Do not share your password with anyone. Sangram Patsanstha will never ask for your passwords or transactional PINs."
          },
          transaction: {
            title: "3. Transaction & Fund Policies",
            desc: "All online fund transfers, loan repayments, and recurring deposit payments are subject to transaction limits and timing. In the event of transaction failures, refund processes are subject to interbank reconciliation timelines."
          },
          availability: {
            title: "4. Service Availability & Interruption",
            desc: "While we strive to keep our digital banking platform online 24/7, services may be interrupted for scheduled updates, server maintenance, or issues outside of our control. We are not liable for transaction delays during these times."
          },
          liability: {
            title: "5. Limitation of Liability",
            desc: "Under no circumstances shall Sangram Patsanstha be liable for any direct, indirect, special, or consequential damages resulting from the use or inability to use our website services, including transaction delays or system failures."
          },
          amendments: {
            title: "6. Amendments to Terms",
            desc: "We reserve the right to revise, modify, or add to these terms at any time. Any changes will be published here with an updated revision date. Continued usage of our services after amendments signifies your acceptance of the updated terms."
          }
        }
      },
      branchesPage: {
        pageTitle: "Our Network",
        pageSubtitle: "Serving 18 major locations in Sangli District with modern cooperative banking infrastructure.",
        quickDirectory: "Quick Directory",
        branchesHeader: "Branches in Every Major City",
        searchPlaceholder: "Search branch by name, village, phone...",
        headOffice: "HEAD OFFICE",
        selected: "SELECTED",
        callHeadOffice: "Call Head Office",
        compliantTitle: "Compliant & Electronically Connected",
        compliantDesc: "Every single village and city branch of Sangram Patsanstha is linked via secured digital servers, offering instant money transfers, secure deposit schemes, and helpful customer care.",
        noBranchesFound: "No bank branches match your query.",
        branchList: {
          "head-office-palus": {
            city: "Head Office, Palus",
            name: "Sangram Patsanstha Head Office",
            address: "Sangram Bhavan Plot No. 187/1 2nd Floor, Tasgaon Karad Road, Industrial Estate, Palus.",
            manager: "Shri. S. R. Patil"
          },
          "audyogik-vasahat": {
            city: "Audyogik Vasahat",
            name: "Audyogik Vasahat Branch",
            address: "Sangram Bhavan Plot No. 187/1 Second Floor, Tasgaon Karad Road, Industrial Estate, Palus.",
            manager: "Smt. S. A. Pawar"
          },
          "sawantpur-vasahat": {
            city: "Sawantpur Vasahat",
            name: "Sawantpur Extension Branch",
            address: "Near the Satyavijay Bank, Sawantpur Colony.",
            manager: "Shri. M. A. Sawant"
          },
          "yelavi": {
            city: "Yelavi",
            name: "Yelavi Village Branch",
            address: "Near Sangli District Central Bank, Yelavi.",
            manager: "Shri. K. D. Patil"
          },
          "tasgaon": {
            city: "Tasgaon",
            name: "Tasgaon Town Branch",
            address: "Joshi Galli, Aditya Bunglow, Tasgaon.",
            manager: "Smt. P. R. Jadhav"
          },
          "savalaj": {
            city: "Savalaj",
            name: "Savalaj Bazar Branch",
            address: "Nikam Galli, Hankare Building, Near Hotel Aashirvaad,Savlaj.",
            manager: "Shri. S. K. Shinde"
          },
          "islampur": {
            city: "Ishwarpur",
            name: "Ishwarpur City Branch",
            address: "Old Vegetable Market, Bramhanpuri, Near Gosavi Hospital, Ishwarpur.",
            manager: "Shri. R. G. Bhosale"
          },
          "shirala": {
            city: "Shirala",
            name: "Shirala Valley Branch",
            address: "Laxmi Chowk, Nath Road, Mangale Road, Shirala.",
            manager: "Shri. A. B. Naik"
          },
          "andhali": {
            city: "Andhali",
            name: "Andhali Gramin Branch",
            address: "Shri. Chhatrapati Shivaji Maharaj Chowk, Aandhali.",
            manager: "Shri. S. V. More"
          },
          "kadegaon": {
            city: "Kadegaon",
            name: "Kadegaon Taluka Branch",
            address: "Kadegaon Tadsar Road Maitreya Park Kadegaon",
            manager: "Shri. V. M. Pawar"
          },
          "vita": {
            city: "Vita",
            name: "Vita Town Branch",
            address: "Muktangan Library, near Vita Karad Road, Vita.",
            manager: "Shri. H. D. Deshmukh"
          },
          "bhilawadi": {
            city: "Bhilawadi",
            name: "Bhilawadi Riverbank Branch",
            address: "Ashta Tasgaon Road ,Opposite Bharati Bazaar, 1st Floor Bhilawadi.",
            manager: "Shri. G. N. Kulkarni"
          },
          "sangli": {
            city: "Sangli",
            name: "Sangli City Branch",
            address: "Ram Mandir, Civil Hospital Road, Aditya Sai Landmark Gala No. 1.",
            manager: "Shri. S. S. Gaikwad"
          },
          "manerajuri": {
            city: "Manerajuri",
            name: "Manerajuri Village Branch",
            address: "In Front of S. T. Stand , behind of I. C. I. C. A. T. M, Manerajuri.",
            manager: "Shri. K. D. Mane"
          },
          "palus-shahar": {
            city: "Palus Shahar",
            name: "Palus City Branch",
            address: "Near Nagoba Temple, Main Road, Palus.",
            manager: "Shri. P. K. Sutar"
          },
          "takari": {
            city: "Takari",
            name: "Takari Junction Branch",
            address: "Near Gram Panchayat, Main Road, Takari.",
            manager: "Shri. D. S. Sutar"
          },
          "aalsand": {
            city: "Aalsand",
            name: "Aalsand Hilly Branch",
            address: "Near Laxmi Temple, Main Road, Aalsand",
            manager: "Shri. V. S. Salunkhe"
          },
          "malwadi": {
            city: "Malwadi",
            name: "Malwadi Rural Branch",
            address: "Near Patil Dairy, Malwadi.",
            manager: "Shri. S. V. Patil"
          }
        }
      }
    }
  },
  mr: {
    translation: {
      navbar: {
        home: "मुख्यपृष्ठ",
        about: "आमच्याबद्दल",
        services: "कर्ज सेवा",
        personalLoan: "वैयक्तिक कर्ज",
        goldLoan: "सोने कर्ज",
        mortgageLoan: "तारण कर्ज",
        loanAgainstDeposit: "ठेव तारण कर्ज",
        businessLoan: "व्यावसायिक कर्ज",
        agricultureLoan: "कृषी संलग्न कर्ज",
        vehicleLoan: "वाहन कर्ज",
        depositSchemes: "ठेव योजना",
        members: "संचालक",
        news: "बातम्या",
        branches: "शाखा",
        gallery: "गॅलरी",
        careers: "करिअर",
        contact: "संपर्क",
        applyLoan: "कर्ज अर्ज करा",
        applyLoanNow: "आता कर्ज अर्ज करा",
        languageTitle: "भाषा",
        languageSelect: "भाषा / निवडा"
      },
      footer: {
        description: "१९९८ पासून विश्वसनीय वित्तीय उपायांद्वारे ग्रामीण समुदायांना सक्षम करत आहोत. तुमची प्रगती हीच आमची प्राथमिकता आहे.",
        quickLinks: "द्रुत लिंक्स",
        ourServices: "आमच्या सेवा",
        allRightsReserved: "सर्व हक्क राखीव.",
        designedBy: "द्वारे डिझाइन केलेले",
        newsUpdates: "बातम्या आणि घडामोडी",
        photoGallery: "फोटो गॅलरी",
        fixedDeposit: "मुदत ठेव (FD)",
        recurringDeposit: "आवर्ती ठेव (RD)",
        savingsAccount: "बचत खाते",
        seniorCitizenScheme: "ज्येष्ठ नागरिक योजना",
        contactInfo: "संपर्क माहिती",
        legalPolicies: "कायदेशीर आणि धोरणे",
        privacyPolicy: "गोपनीयता धोरण",
        termsConditions: "अटी आणि शर्ती",
        designDevelopedBy: "द्वारे डिझाइन आणि विकसित केलेले",
        address: "संग्राम भवन, कराड तासगाव रोड, पलूस, ता. पलूस, जि. सांगली."
      },
      aboutPage: {
        aboutUs: "आमच्याबद्दल",
        aboutSubtitle: "१९९८ पासून व्यावसायिक सहकारी बँकिंगद्वारे ग्रामीण स्वप्नांना सक्षम करणे.",
        ourStoryBadge: "आमची कथा",
        titleSangram: "संग्राम",
        titlePatsanstha: "पतसंस्था",
        subtitle: "एका लहान बीजापासून ते एका महाकाय वटवृक्षापर्यंत: विश्वास आणि सहकारी शक्तीच्या माध्यमातून आम्ही आमचे सभासद आणि ग्रामीण समुदायांच्या उन्नतीसाठी समर्पित आहोत.",
        para1: "१९९८ मध्ये, संग्राम पतसंस्थेचा जन्म एका साध्या पण प्रभावी कल्पनेतून झाला: आपल्या देशाच्या ग्रामीण भागाला मदतीचा हात देणे. आमच्या संस्थापकांनी अशा एका वित्तीय संस्थेची संकल्पना मांडली जी केवळ आकड्यांपुरती मर्यादित नसेल, तर लोकांसाठी असेल - शेतकरी, लहान व्यावसायिक आणि चांगल्या उद्यासाठी प्रयत्नशील असलेली कुटुंबे.",
        para2: "आज, आम्ही आर्थिक आशेचा एक किरण म्हणून उभे आहोत, आर्थिक संकटांचा सामना करून आणि डिजिटल क्रांतीचा स्वीकार करून, आमच्या सहकार आणि पारदर्शकतेच्या मूळ मूल्यांना नेहमी अग्रस्थानी ठेवले आहे.",
        exploreBranches: "आमच्या शाखा पहा",
        foundersMessageTitle: "संस्थापकांच्या मनोगतातून",
        inspiration: "आमचे प्रेरणास्थान",
        founderName: "स्व. विठ्ठलराव (बापूसो) बबनराव येसुगडे",
        founderRole: "संस्थापक संग्राम उद्योग समूह, पलूस",
        founderMessage: "आमच्या भागातील प्रत्येक शेतकरी, लहान व्यापारी आणि कुटुंबाला प्रामाणिक, पारदर्शक आणि सहकारी बँकिंगचा लाभ मिळायला हवा, असा आमचा ठाम विश्वास होता. आज, हजारो सभासदांच्या हृदयात ते स्वप्न फुलताना पाहून आम्हास अत्यंत अभिमान वाटतो. आमचे ध्येय केवळ पतसंस्था स्थापन करणे हे नव्हते, तर ग्रामीण समुदायासाठी विश्वास, वृद्धी आणि सुरक्षिततेची एक परिसंस्था निर्माण करणे हे होते.",
        founderQuote: "सामान्यांना सक्षम करणे हे सहकाराच्या शक्तीचे खरे रूप आहे.",
        founderSub: "बापूसाहेब येसुगडे संग्राम ग्रामीण बिगरशेती सहकारी पतसंस्था मर्यादित, पलूस.",
        chairmansCornerTitle: "अध्यक्षांच्या मनोगतातून",
        visionRole: "आमचे मार्गदर्शक",
        chairmanName: "श्री. निलेश विठ्ठलराव येसुगडे",
        chairmanRole: "अध्यक्ष, बापूसाहेब येसुगडे संग्राम उद्योग समूह, पलूस.",
        chairmanMessage: "आमचे ध्येय प्रत्येक सभासदाला आर्थिक स्थैर्य आणि आधुनिक बँकिंग सेवांद्वारे सक्षम करणे हे आहे. संग्राम पतसंस्थेमध्ये, आम्ही केवळ बँकिंग सेवा पुरवत नाही; तर परस्पर विश्वास आणि नाविन्यपूर्ण वित्तीय सेवांच्या माध्यमातून कायमस्वरूपी नाते निर्माण करतो आणि समुदायाच्या विकासाला चालना देतो.",
        chairmanQuote: "जेव्हा समुदाय एकत्र वाढतो, तीच खरी प्रगती असते.",
        chairmanCornerLabel: "आमच्या सभासदांसाठी संदेश",
        corePurposeBadge: "आमचा मुख्य हेतू",
        corePurposeTitle: "उज्वल आर्थिक भविष्य घडवत आहोत",
        corePurposeDesc: "आम्ही एकाच ध्येयाने प्रेरित आहोत: विश्वास, नाविन्य आणि सचोटीवर आधारित सहकारी वित्तीय सेवांच्या माध्यमातून आमचे सभासद आणि ग्रामीण समुदायांची प्रगती करणे.",
        missionBadge: "आमचे ध्येय",
        missionTitle: "ग्रामीण समृद्धीला चालना देणे",
        missionDesc: "सहकारी मूल्यांच्या माध्यमातून आर्थिक स्वातंत्र्य आणि शाश्वत विकासाला चालना देत, ग्रामीण समुदायाला उच्च-दर्जाच्या, पारदर्शक आणि सुलभ वित्तीय सेवा प्रदान करणे.",
        visionBadge: "आमचा दृष्टिकोन",
        visionTitle: "प्रत्येक सभासदाचे सक्षमीकरण",
        visionDesc: "ग्रामीण विकासासाठीच्या आमच्या वचनबद्धतेसाठी आणि आमच्या सभासदांसाठी शाश्वत आर्थिक समृद्धी निर्माण करण्यासाठी ओळखली जाणारी, सर्वात विश्वासू आणि नाविन्यपूर्ण सहकारी संस्था होणे.",
        pillarsBadge: "आमचे आधारस्तंभ",
        pillarsTitle: "आम्हामार्गदर्शन करणारी तत्त्वे",
        pillarsDesc: "आमची मूळ मूल्ये आमच्या संस्थेचा पाया आहेत, ज्यामुळे आम्ही आमच्या सर्व व्यवहारांमध्ये पारदर्शकता, स्थानिक सक्षमीकरण आणि उत्कृष्टतेसाठी वचनबद्ध राहतो.",
        integrityTitle: "सचोटी",
        integrityDesc: "आम्ही आमच्या सर्व व्यवहारांमध्ये व्यावसायिक नैतिकता आणि पारदर्शकतेचे सर्वोच्च निकष राखतो.",
        communityTitle: "समुदाय",
        communityDesc: "आमचे लक्ष नेहमीच आमच्या स्थानिक समुदाय आणि सभासदांच्या कल्याणावर आणि विकासावर असते.",
        excellenceTitle: "उत्कृष्टता",
        excellenceDesc: "आम्ही नाविन्यता आणि ग्राहक-केंद्रिततेच्या माध्यमातून उत्कृष्ट वित्तीय सेवा प्रदान करण्याचा प्रयत्न करतो.",
        trustTitle: "विश्वास",
        impactBadge: "आमचा प्रभाव",
        impactTitle: "आकड्यांच्या माध्यमातून समृद्धी वाढवणे",
        impactDesc: "आमच्या सहकारी कार्याने प्रत्येक आकडा एका सक्षम झालेल्या आयुष्याचे आणि पाठबळ मिळालेल्या स्वप्नाचे प्रतिनिधित्व करतो.",
        awardsBadge: "पुरस्कार व सन्मान",
        awardsTitle: "उत्कृष्टतेचा गौरव",
        awardsSubtitle: "सहकारी बँकिंग क्षेत्रातील आमची कटिबद्धता आणि प्राप्त झालेला सन्मान.",
        clickToEnlarge: "मोठ्या आकारात पाहण्यासाठी क्लिक करा",
        closeView: "बंद करा"
      },
      homePage: {
        happyMembers: "आनंदी सभासद",
        totalDeposits: "एकूण ठेवी",
        loansDisbursed: "वितरित कर्जे",
        yearsOfTrust: "विश्वासाची वर्षे",
        learnMore: "अधिक जाणून घ्या",
        applyNow: "आता अर्ज करा",
        aboutBadge: "संग्राम पतसंस्थेबद्दल",
        aboutTitle: "१९९५ पासून ग्रामीण समुदायांचे सक्षमीकरण",
        aboutPara1: "संग्राम पतसंस्थेची स्थापना ज्यांना वित्तीय सेवांची सर्वात जास्त गरज आहे अशा लोकांना सुलभ आणि परवडणाऱ्या सेवा प्रदान करण्याच्या दृष्टीकोनातून करण्यात आली. आमचा ठाम विश्वास आहे की खरी प्रगती तळागाळापासून सुरू होते.",
        aboutPara2: "दशकांहून अधिक काळ, आम्ही एका लहान सहकार संस्थेपासून एका आघाडीच्या वित्तीय संस्थेपर्यंत वाटचाल केली आहे, ५०,००० हून अधिक सभासदांना अतूट विश्वास आणि व्यावसायिक सचोटीने सेवा देत आहोत.",
        readOurStory: "आमची कथा वाचा",
        planFinancesTitle: "तुमच्या वित्तीचे नियोजन करा",
        planFinancesDesc: "तुमच्या कर्जाच्या हप्त्यांचा (EMI) अंदाज घेण्यासाठी किंवा तुमच्या मुदत ठेवीच्या (FD) परिपक्वता मूल्याची सहज गणना करण्यासाठी आमच्या स्मार्ट कॅल्क्युलेटरचा वापर करा.",
        ctaTitle: "प्रत्येक ग्रामीण कुटुंबासाठी आर्थिक ताकद निर्माण करत आहोत",
        ctaDesc: "हजारो समाधानी सभासदांमध्ये सामील व्हा आणि संग्राम पतसंस्थेसोबत आर्थिक समृद्धीच्या देशाने प्रवास सुरू करा.",
        contactUsBtn: "आमच्याशी संपर्क साधा",
        trustInNumbers: "आकड्यांमधील विश्वास",
        trustInNumbersDesc: "आमची वाढ ही या भागातील हजारो कुटुंबे आणि व्यवसायांनी आमच्यावर ठेवलेल्या विश्वासाची साक्ष आहे.",
        happyCustomers: "आनंदी ग्राहक",
        loansDistributed: "वितरित कर्जे",
        investment: "गुंतवणूक",
        villagesConnected: "जोडलेली गावे",
        yearsOfService: "सेवेची वर्षे",
        heroTitle: "विश्वासू बँकिंगसह ग्रामीण विकासाचे सक्षमीकरण",
        heroSubtitle: "तुमच्या समृद्धीसाठी आणि अधिक उज्वल उद्यासाठी सुरक्षित बचत, सुलभ कर्जे आणि समुदायावर केंद्रित वित्तीय सेवा.",
        heroButtonText: "कर्जासाठी अर्ज करा",
        servicesBadge: "आमच्या कर्ज सेवा",
        servicesTitle: "प्रत्येक गरजेसाठी विश्वासार्ह आर्थिक पर्याय",
        viewAllServices: "सर्व सेवा पहा",
        customLoanTitle: "सानुकूलित कर्ज हवे आहे का?",
        customLoanDesc: "तुमच्या गरजांना तंतोतंत जुळणाऱ्या सानुकूलित आर्थिक समाधानासाठी आजच आमच्या तज्ज्ञांशी चर्चा करा.",
        contactExpert: "तज्ज्ञांशी संपर्क साधा",
        learnMoreLink: "अधिक जाणून घ्या",
        personalLoanTitle: "वैयक्तिक कर्ज",
        personalLoanDesc: "तुमच्या वैयक्तिक गरजा, वैद्यकीय आणीबाणी किंवा कौटुंबिक समारंभांसाठी कमीत कमी कागदपत्रांसह जलद आर्थिक मदत.",
        goldLoanTitle: "सोने कर्ज",
        goldLoanDesc: "आपल्या सोन्याच्या दागिन्यांवर त्वरित व सुरक्षित कर्ज सुविधा मिळवा. कमी कागदपत्रे, जलद मंजुरी आणि आकर्षक व्याजदरांसह आपल्या आर्थिक गरजा सहज पूर्ण करा.",
        mortgageLoanTitle: "तारण कर्ज",
        mortgageLoanDesc: "घर, जमीन किंवा इतर मालमत्ता तारण ठेवून मोठ्या रकमेचे कर्ज मिळवा. व्यवसाय विस्तार, शिक्षण, वैद्यकीय खर्च किंवा इतर महत्त्वाच्या गरजांसाठी विश्वासार्ह आर्थिक मदत.",
        businessLoanTitle: "व्यावसायिक कर्ज",
        businessLoanDesc: "आपला व्यवसाय सुरू करण्यासाठी, वाढवण्यासाठी किंवा आधुनिक करण्यासाठी आर्थिक सहाय्य मिळवा. स्पर्धात्मक व्याजदर, सुलभ परतफेड आणि जलद कर्ज मंजुरीसह व्यवसायाच्या प्रगतीला नवी गती द्या.",
        agricultureLoanTitle: "कृषी संलग्न कर्ज",
        agricultureLoanDesc: "शेतीची उत्पादकता वाढवण्यासाठी बियाणे, खते, यंत्रसामग्री आणि सिंचनासाठी आमच्या शेतकऱ्यांना कमी व्याजदराच्या कर्जासह पाठबळ देणे.",
        vehicleLoanTitle: "वाहन कर्ज",
        vehicleLoanDesc: "आमच्या सुलभ, जलद आणि त्रासरहित वाहन कर्ज पर्यायांसह तुमचे स्वप्नातील वाहन घरी आणा.",
        depositBadge: "भविष्यासाठी गुंतवणूक",
        depositTitle: "उच्च-वाढीच्या ठेव योजना",
        depositDesc: "सुरक्षितता, तरलता आणि उच्च परतावा देणाऱ्या आमच्या आकर्षक ठेव योजनांसह तुमचे कष्टाचे पैसे सुरक्षित करा.",
        knowMoreBtn: "अधिक जाणून घ्या",
        notSureScheme: "कोणती योजना निवडायची याबद्दल खात्री नाही?",
        compareRatesDesc: "आमचे दर तपासा आणि तुमच्या परताव्याची त्वरित गणना करा.",
        interestRatesBtn: "व्याजदर",
        emiCalculatorBtn: "EMI कॅल्क्युलेटर",
        whyChooseUsBadge: "संग्राम पतसंस्था का?",
        whyChooseUsTitle: "आर्थिक यशासाठी तुमचा विश्वासू भागीदार",
        whyChooseUsDesc: "आम्ही केवळ एक पतसंस्था नाही. आम्ही एक समुदाय-चालित संस्था आहोत जी तुम्हाला तुमची स्वप्ने साध्य करण्यात मदत करण्यासाठी सर्वोत्तम आर्थिक साधने आणि पाठबळ प्रदान करण्यासाठी समर्पित आहे.",
        rbiCompliantTitle: "आरबीआय (RBI) सुसंगत",
        rbiCompliantSub: "सुरक्षित आणि नियंत्रित",
        secureBankingTitle: "सुरक्षित बँकिंग",
        secureBankingDesc: "तुमचे पैसे बहु-स्तरीय सुरक्षा आणि अत्याधुनिक कूटबद्धतेसह (encryption) सुरक्षित आहेत.",
        fastApprovalsTitle: "जलद मंजुरी",
        fastApprovalsDesc: "कमीत कमी कागदपत्रांसह २४ ते ४८ तासांत तुमचे कर्ज मंजूर करून घ्या.",
        lowInterestTitle: "कमी व्याजदर",
        lowInterestDesc: "ग्रामीण विकासासाठी डिझाइन केलेल्या कर्जांवर स्पर्धात्मक व्याजदरांचा लाभ घ्या.",
        transparencyTitle: "पारदर्शकता",
        transparencyDesc: "कोणतेही छुपे शुल्क किंवा अटी नाहीत. आमचा १००% प्रामाणिक बँकिंगवर विश्वास आहे."
      },
      loanDetails: {
        loanOverview: "कर्ज संक्षिप्त माहिती ",
        keyBenefits: "मुख्य फायदे",
        requirementsAndDocs: "कर्ज पात्रता आणि कागदपत्रे",
        eligibility: "पात्रता",
        documentsRequired: "आवश्यक कागदपत्रे",
        loanFileOrder: "कर्ज फाईल कागदपत्रांचा अनुक्रम",
        guarantorDocs: "जामीनदाराची आवश्यक कागदपत्रे",
        mediumTermDocs: "मध्यम मुदत कर्जासाठी आवश्यक कागदपत्रे",
        siteInspectionDocs: "शाखा अधिकारी स्थळ पाहणी अहवाल",
        faqs: "वारंवार विचारले जाणारे प्रश्न (FAQ)",
        interestRate: "व्याजदर",
        startingFrom: "प्रति वर्ष पासून सुरू",
        applyButton: "कर्जासाठी अर्ज करा",
        terms: "*अटी आणि शर्ती लागू",
        needAssistance: "मदतीची गरज आहे?",
        fastApproval: "जलद मंजुरी",
        fastApprovalTime: "२४ ते ४८ तास",
        talkExperts: "आमच्या तज्ज्ञांशी बोला"
      },
      membersPage: {
        pageTitle: "संचालक मंडळ",
        pageSubtitle: "सन २०२३-२४ ते २०२८-२९",
        leadership: "नेतृत्व",
        boardOfDirectors: "संचालक मंडळ",
        noMembers: "कोणतेही संचालक आढळले नाहीत.",
        joinTeamTitle: "आमच्या संघात सामील होऊ इच्छिता?",
        joinTeamDesc: "आम्ही नेहमी अशा उत्साही व्यक्तींच्या शोधात असतो ज्यांना ग्रामीण वित्तीय क्षेत्रात बदल घडवून आणायचा आहे.",
        viewCareers: "करिअरच्या संधी पहा",
        yearsOfExperience: "वर्षांचा",
        experience: "अनुभव",
        tenure: "सन २०२३-२४ ते २०२८-२९"
      },
      depositPage: {
        pageTitle: "ठेव योजना",
        pageSubtitle: "प्रत्येक गरजेसाठी तयार केलेल्या आमच्या उच्च-व्याज गुंतवणूक योजनांसह तुमचे भविष्य सुरक्षित करा.",
        annualInterest: "व्याज",
        planOverview: "योजना संक्षिप्त माहिती",
        schemeDetails: "योजना तपशील",
        noSchemesTitle: "सध्या कोणतीही ठेव योजना उपलब्ध नाही",
        noSchemesDesc: "कृपया आमच्या अद्ययावत गुंतवणूक योजनांसाठी नंतर पुन्हा तपासा.",
        fixedDeposit: "मुदत ठेव (FD)",
        recurringDeposit: "आवर्ती ठेव (RD)",
        savingsAccount: "बचत खाते",
        seniorCitizenScheme: "ज्येष्ठ नागरिक ठेव योजना",
        year: "वर्ष",
        years: "वर्षे",
        interestRateTableTitle: "चालू ठेव व्याजदर (दि. ०२/०५/२०२६ पासून)",
        tableColSrNo: "अ. क्र.",
        tableColDepositType: "ठेवीचा प्रकार",
        tableColDuration: "मुदत",
        tableColInterestRate: "नवीन व्याजदर (दि. ०२/०५/२०२६ पासून)",
        savingDeposit: "सेव्हिंग ठेव",
        termDeposit: "मुदत ठेव",
        silverJubileeDeposit: "बापूसाहेब येसुगडे रौप्यमहोत्सव ठेव",
        sangramDeposit: "संग्राम ठेव",
        doubleMoneyDeposit: "दामदुप्पट ठेव",
        oneAndHalfMoneyDeposit: "दामदिडपट ठेव",
        durDays46To180: "४६ दिवस ते १८० दिवस",
        durDays181To365: "१८१ दिवस ते ३६५ दिवस",
        durMonths15: "१ वर्षे ३ महिने (१५ महिने)",
        durMonths13Monthly: "१ वर्षे १ महिना (मासिक व्याजाची सोय)",
        durSeniorCitizenMonthly: "ज्येष्ठ नागरिक (मासिक व्याज)",
        durMonths90: "९० महिने",
        durMonths67: "६७ महिने"
      },
      newsPage: {
        pageTitle: "बातम्या आणि घडामोडी",
        pageSubtitle: "बँकेच्या ताज्या घोषणा, आर्थिक टिप्स आणि सामाजिक कार्यक्रमांविषयी अद्ययावत रहा.",
        searchPlaceholder: "लेख शोधा...",
        noNewsFound: "तुमच्या निकषांशी जुळणाऱ्या कोणत्याही बातम्या आढळल्या नाहीत.",
        readFullStory: "पूर्ण बातमी वाचा",
        backToNews: "बातम्यांवर परत जा",
        byAuthor: "द्वारे",
        shareStory: "ही बातमी शेअर करा",
        tags: "टॅग्ज:"
      },
      galleryPage: {
        pageTitle: "फोटो गॅलरी",
        pageSubtitle: "अनेक वर्षांतील आमची प्रगती, समाजसेवा आणि प्रवासाचे क्षण टिपत आहोत.",
        noImagesFound: "या श्रेणीत कोणतेही फोटो आढळले नाहीत.",
        all: "सर्व",
        eventPhotos: "कार्यक्रम फोटो",
        officeImages: "कार्यालयीन छायाचित्रे",
        programs: "कार्यक्रम",
        socialActivity: "सामाजिक उपक्रम"
      },
      careersPage: {
        pageTitle: "करिअर",
        pageSubtitle: "विश्वास आणि आर्थिक नाविन्यतेच्या माध्यमातून समुदायांना सक्षम करण्याच्या आमच्या मोहिमेत सामील व्हा.",
        ourCulture: "आमची संस्कृती",
        whyStartCareer: "मध्ये तुमचे करिअर का सुरू करावे?",
        whyStartCareerDesc: "आम्ही केवळ नोकऱ्या देत नाही; तर आम्ही व्यावसायिक प्रगती आणि सामाजिक प्रभावाचा मार्ग देतो.",
        growthMindset: "प्रगतीशील विचारसरणी",
        growthMindsetDesc: "आम्ही तुमच्या शिकण्यात गुंतवणूक करतो आणि करिअरच्या प्रगतीचे स्पष्ट मार्ग प्रदान करतो.",
        collaborativeTeam: "सहयोगी टीम",
        collaborativeTeamDesc: "एकमेकांसोबत काम करा आणि सर्वसमावेशक वातावरणात उत्साही व्यावसायिकांसह काम करा.",
        industryRecognition: "क्षेत्रातील मान्यता",
        industryRecognitionDesc: "२८+ वर्षांहून अधिक उत्कृष्टतेचा वारसा लाभलेल्या एका विश्वासू सहकारी संस्थेचा भाग व्हा.",
        currentOpenings: "सध्याच्या रिक्त जागा",
        activePositions: "सक्रिय पदे",
        noOpenPositions: "सध्या कोणत्याही जागा उपलब्ध नाहीत",
        checkBackLater: "कृपया नंतर पुन्हा तपासा किंवा खाली सामान्य चौकशी सादर करा.",
        didntFindTitle: "तुम्ही जे शोधत आहात ते सापडले नाही का?",
        didntFindDesc: "तरीही तुमचे सीव्ही (CV) आम्हाला पाठवा! आम्ही नेहमीच आमच्या वाढत्या कुटुंबामध्ये सामील होण्यासाठी प्रतिभावान व्यक्तींच्या शोधात असतो.",
        dropCV: "तुमचे सीव्ही (CV) सबमिट करा",
        applyNow: "आता अर्ज करा",
        fullTime: "पूर्णवेळ",
        vacancies: "रिक्त जागा"
      },
      jobApplicationPage: {
        pageHeaderTitle: "करिअरसाठी अर्ज करा",
        pageHeaderSubtitle: "संग्राम पतसंस्थेमध्ये {{position}} पदासाठी अर्ज करा.",
        careerOpportunity: "करिअरची संधी",
        takeNextStep: "तुमच्या व्यावसायिक प्रवासात",
        professionalJourney: "पुढचे पाऊल टाका",
        whyJoinDesc: "आम्ही अशा व्यक्तींच्या शोधात आहोत ज्यांना सहकारी बँकिंग आणि समाजसेवेची आवड आहे. आमच्यात सामील व्हा आणि बदल घडवा.",
        equalOpportunity: "समान संधी",
        equalOpportunityDesc: "आम्ही विविधतेचा आदर करतो आणि सर्वसमावेशक वातावरण तयार करण्यासाठी वचनबद्ध आहोत.",
        reviewTimeline: "पुनरावलोकन कालावधी",
        reviewTimelineDesc: "आमची एचआर (HR) टीम साधारणपणे ७-१० कामकाजाच्या दिवसांत अर्जांचे पुनरावलोकन करते.",
        applicationTips: "अर्ज करण्यासाठी टिप्स",
        applicationTipsDesc: "तुमची संपर्क माहिती अचूक असल्याची आणि तुमचा रेझ्युमे अद्ययावत असल्याची खात्री करा.",
        secureApplication: "सुरक्षित अर्ज",
        gdprCompliant: "जीडीपीआर (GDPR) आणि डेटा गोपनीयता सुसंगत",
        applicationForm: "अर्ज पत्रक",
        fullName: "पूर्ण नाव",
        fullNamePlaceholder: "तुमचे पूर्ण नाव प्रविष्ट करा",
        email: "ईमेल पत्ता",
        emailPlaceholder: "email@example.com",
        contactNumber: "संपर्क क्रमांक",
        cityLocation: "शहर / ठिकाण",
        cityPlaceholder: "उदा. पलूस",
        applyingPosition: "पदासाठी अर्ज करत आहात",
        yearsExperience: "अनुभवाची वर्षे",
        selectExperience: "अनुभव निवडा",
        fresher: "फ्रेशर (० वर्षे)",
        exp1_2: "१-२ वर्षे",
        exp3_5: "३-५ वर्षे",
        exp5_10: "५-१० वर्षे",
        exp10_plus: "१०+ वर्षे",
        uploadResume: "रेझ्युमे अपलोड करा (फक्त PDF - कमाल १MB)",
        readyToUpload: "अपलोड करण्यासाठी तयार",
        dropResume: "तुमचा रेझ्युमे येथे ड्रॉप करा किंवा ब्राउझ करण्यासाठी क्लिक करा",
        supportPdfOnly: "समर्थन: फक्त PDF (कमाल १MB)",
        submitApplication: "अर्ज सादर करा",
        successTitle: "अर्ज प्राप्त झाला!",
        successText: "तुमच्या आवडीबद्दल धन्यवाद. आमची एचआर (HR) टीम तुमच्या प्रोफाइलचे पुनरावलोकन करेल आणि निवड झाल्यास तुमच्याशी संपर्क साधेल.",
        errorTitle: "अर्ज सादर करणे अयशस्वी",
        errorText: "तुमचा अर्ज सबमिट करताना तांत्रिक अडचण आली. कृपया काही वेळानंतर पुन्हा प्रयत्न करा.",
        validationTitle: "त्रुटी",
        validationText: "रेझ्युमेचा आकार १MB पेक्षा जास्त नसावा"
      },
      contactPage: {
        pageHeaderTitle: "आमच्याशी संपर्क साधा",
        pageHeaderSubtitle: "काही प्रश्न आहेत किंवा मदतीची गरज आहे? आमची टीम तुमच्या सेवेसाठी येथे आहे.",
        callUs: "आम्हाला कॉल करा",
        emailUs: "आम्हाला ईमेल करा",
        visitUs: "आम्हाला भेट द्या",
        availableHrs: "सोम-शनि उपलब्ध, सकाळी १०:३० ते संध्याकाळी ६",
        weRespond: "आम्ही २४ तासांच्या आत प्रतिसाद देतो",
        addressDetails: "कराड तासगाव रोड, पलूस, ता. पलूस, जि. सांगली.",
        addressText: "संग्राम भवन",
        sendMessage: "आम्हाला संदेश पाठवा",
        fullName: "पूर्ण नाव",
        fullNamePlaceholder: "तुमचे पूर्ण नाव प्रविष्ट करा",
        email: "ईमेल पत्ता",
        emailPlaceholder: "email@example.com",
        phoneNumber: "फोन नंबर",
        inquiryType: "चौकशीचा प्रकार",
        selectOption: "पर्याय निवडा",
        generalInquiry: "सामान्य चौकशी",
        personalLoan: "वैयक्तिक कर्ज",
        goldLoan: "सोने कर्ज",
        businessLoan: "व्यावसायिक कर्ज",
        fixedDeposit: "मुदत ठेव (FD)",
        socialActivity: "सामाजिक उपक्रम",
        yourMessage: "तुमचा संदेश",
        messagePlaceholder: "आम्ही आज तुम्हाला कशी मदत करू शकतो?",
        sendMessageBtn: "संदेश पाठवा",
        sendingMessageBtn: "संदेश पाठवत आहे...",
        successTitle: "यशस्वी!",
        successText: "तुमचा संदेश यशस्वीरित्या पाठवला गेला आहे. आमची टीम लवकरच तुमच्याशी संपर्क साधेल.",
        errorTitle: "चौकशी सादर करणे अयशस्वी",
        errorText: "संदेश पाठवता आला नाही. कृपया काही वेळानंतर पुन्हा प्रयत्न करा."
      },
      loanApplicationPage: {
        pageHeaderTitle: "कर्ज अर्ज करा",
        pageHeaderSubtitle: "सुलभ आणि सुलभ कर्ज समाधानासह तुमच्या आर्थिक प्रवासाला सक्षम बनवत आहोत.",
        quickApplication: "त्वरित अर्ज",
        turnDreamsTitle: "तुमची स्वप्ने",
        into: "",
        reality: "सत्यात ",
        today: "आजच उतरवा",
        intoRealitySubtitle: "तुमच्या आर्थिक उद्दिष्टांच्या देशाने पहिले पाऊल टाका. नवीन घर असो, व्यवसायाचा विस्तार असो किंवा वैयक्तिक टप्पे असोत, आम्ही तुम्हाला पाठबळ देण्यासाठी येथे आहोत.",
        trustedMembers: "५०,०००+ सभासदांचा विश्वास",
        safeProcessing: "सुरक्षित आणि पारदर्शक प्रक्रिया",
        whyChooseTitle: "आमचे कर्ज का निवडावे?",
        whyChooseItem1: "बाजारातील स्पर्धात्मक व्याजदर",
        whyChooseItem2: "कमीत कमी कागदपत्रे आणि पेपरलेस प्रक्रिया",
        whyChooseItem3: "लवचिक परतफेडीचे पर्याय (EMIs)",
        whyChooseItem4: "कोणतेही छुपे शुल्क किंवा प्रक्रियेत विलंब नाही",
        whyChooseItem5: "२४ तासांच्या आत जलद आणि त्रासमुक्त कर्ज वितरण",
        whyChooseItem6: "तज्ज्ञ सल्लागारांच्या मार्गदर्शनासह अत्यंत विश्वसनीय सहकारी सेवा",
        loanApplicationForm: "कर्ज अर्ज पत्रक",
        accurateInfoDesc: "कृपया जलद प्रक्रियेसाठी अचूक माहिती द्या.",
        fullName: "पूर्ण नाव",
        fullNamePlaceholder: "तुमचे पूर्ण नाव प्रविष्ट करा",
        email: "ईमेल पत्ता",
        emailPlaceholder: "email@example.com",
        contactNumber: "संपर्क क्रमांक",
        phonePlaceholder: "उदा. +९१ ९८७६५ ४३२१०",
        cityLocation: "शहर / ठिकाण",
        cityPlaceholder: "उदा. पुणे",
        loanType: "कर्जाचा प्रकार",
        requiredAmount: "आवश्यक रक्कम (₹)",
        requiredAmountPlaceholder: "उदा. ५०००००",
        applyNow: "आता अर्ज करा",
        needHelp: "मदतीची गरज आहे? आमच्या समर्थनाला कॉल करा:",
        successTitle: "अर्ज सादर केला!",
        successText: "संग्राम पतसंस्था निवडल्याबद्दल धन्यवाद. आमचे कर्ज अधिकारी २४ तासांच्या आत तुमच्याशी संपर्क साधतील.",
        errorTitle: "अर्ज सादर करणे अयशस्वी",
        errorText: "काहीतरी त्रुटी आली. कृपया पुन्हा प्रयत्न करा किंवा आमच्या जवळच्या शाखेला भेट द्या."
      },
      privacyPolicyPage: {
        pageTitle: "गोपनीयता धोरण",
        pageSubtitle: "आम्ही तुमच्या विश्वासाला महत्त्व देतो. आम्ही तुमची वैयक्तिक आणि आर्थिक माहिती कशी सुरक्षित ठेवतो आणि व्यवस्थापित करतो ते जाणून घ्या.",
        trustedSecurityTitle: "विश्वसनीय बँकिंग सुरक्षा",
        trustedSecurityDesc: "तुमचा डेटा सुरक्षित आहे आणि राष्ट्रीय नियामक मानकांनुसार हाताळला जाईल याची हमी देण्यासाठी आम्ही आमच्या फायरवॉल आणि अंतर्गत अनुपालन मार्गदर्शक तत्त्वे सतत अद्यतनित करतो.",
        lastUpdated: "शेवटचे अद्यतन: मे २०२६",
        questionsTitle: "आमच्या गोपनीयतेच्या पद्धतींबद्दल काही प्रश्न आहेत का?",
        questionsDesc: "या गोपनीयता धोरणाबाबत तुम्हाला काही प्रश्न, चिंता किंवा विनंत्या असल्यास, कृपया आमच्या डेटा संरक्षण अधिकाऱ्याला येथे लिहा:",
        email: "ईमेल",
        address: "पत्ता",
        sections: {
          commitment: {
            title: "आमची गोपनीयता वचनबद्धता",
            desc: "संग्राम पतसंस्थेमध्ये, तुमची गोपनीयता ही आमची सर्वोच्च प्राथमिकता आहे. आम्ही अत्याधुनिक सुरक्षा यंत्रणा आणि कठोर कार्यान्वयन प्रोटोकॉलद्वारे तुमची वैयक्तिक आणि आर्थिक माहिती सुरक्षित ठेवण्यासाठी वचनबद्ध आहोत."
          },
          collect: {
            title: "आम्ही गोळा करतो ती माहिती",
            desc: "तुम्ही आमच्या ऑनलाइन पोर्टलचा वापर करता तेव्हा आम्ही वैयक्तिक ओळख तपशील (नाव, पॅन, आधार, पत्ता), संपर्क माहिती, आर्थिक व्यवहारांचा इतिहास, रोजगाराचा तपशील आणि डिजिटल फूटप्रिंट डेटा गोळा करतो."
          },
          protect: {
            title: "आम्ही तुमच्या डेटाचे संरक्षण कसे करतो",
            desc: "सर्व संवेदनशील व्यवहार डेटा प्रगत २५६-बिट SSL कूटबद्धीकरण (encryption) वापरून सुरक्षित केला जातो. आम्ही आमचा डेटा बँक-दर्जाच्या, सुरक्षित क्लाउड सर्व्हरमध्ये ठेवतो आणि कर्मचाऱ्यांच्या प्रवेशावर केवळ आवश्यकतेनुसार कठोर निर्बंध घालतो."
          },
          sharing: {
            title: "माहिती सामायिकरण धोरण",
            desc: "आम्ही तुमची वैयक्तिक माहिती कधीही विकत नाही. कायद्यानुसार आवश्यक असेल तेव्हा किंवा तुमचे व्यवहार पूर्ण करण्यासाठी आवश्यक असेल तेव्हाच आम्ही अधिकृत क्रेडिट ब्युरो, सरकारी एजन्सी आणि भागीदार संस्थांसोबत डेटा सामायिक करतो."
          },
          rights: {
            title: "तुमचे डेटा हक्क",
            desc: "आमच्याकडे संग्रहित केलेल्या तुमच्या वैयक्तिक डेटाचे पुनरावलोकन, अद्यतन किंवा दुरुस्ती करण्याचे तुम्हाला पूर्ण अधिकार आहेत. तुम्ही तुमच्या डेटाच्या सारांशाची विनंती करू शकता किंवा कोणत्याही वेळी विशिष्ट प्रचारात्मक सूचनांमधून बाहेर पडू शकता."
          },
          cookies: {
            title: "कुकीज आणि विश्लेषण",
            desc: "आम्ही वेब ट्रॅफिकचे विश्लेषण करण्यासाठी, तुमची प्राधान्ये लक्षात ठेवण्यासाठी आणि एक सानुकूलित बँकिंग अनुभव देण्यासाठी कुकीजचा वापर करतो. तुम्ही तुमच्या वेब ब्राउझर सेटिंग्जमधून कुकी प्राधान्ये थेट व्यवस्थापित करू शकता."
          }
        }
      },
      termsConditionsPage: {
        pageTitle: "अटी आणि शर्ती",
        pageSubtitle: "कृपया आमच्या बँकिंग सेवांच्या वापराचे नियमन करणारे कायदेशीर नियम, मार्गदर्शक तत्त्वे आणि अटींचे पुनरावलोकन करा.",
        officialAgreementTitle: "अधिकृत सेवा करार",
        officialAgreementDesc: "आमच्या वेबसाइटवर प्रवेश करून आणि आमच्या कोणत्याही ठेव योजना, कर्ज चौकशी पोर्टल किंवा ऑनलाइन प्लॅटफॉर्मचा वापर करून, तुम्ही हे मान्य करता की तुम्ही या अटी आणि शर्ती वाचल्या आहेत, समजल्या आहेत आणि त्यांच्याशी बांधील राहण्यास सहमत आहात.",
        version: "आवृत्ती २.४ (सक्रिय)",
        governingLawTitle: "लागू कायदा आणि विवाद निवारण",
        governingLawDesc: "या अटी आणि शर्तींचे नियंत्रण भारतीय प्रजासत्ताकच्या कायद्यांनुसार केले जाईल आणि त्यानुसार त्यांचा अर्थ लावला जाईल. या अटींच्या संदर्भात उद्भवणारे कोणतेही विवाद पुणे, महाराष्ट्र येथील सक्षम न्यायालयांच्या अनन्य अधिकार क्षेत्राच्या अधीन असतील.",
        terms: {
          membership: {
            title: "१. खाते आणि सभासदत्व अटी",
            desc: "सभासदत्व हे संचालक मंडळाद्वारे पडताळणी आणि मंजुरीच्या अधीन आहे. नोंदणी दरम्यान प्रदान केलेली सर्व माहिती खरी असणे आवश्यक आहे. माहितीमध्ये कोणतीही असत्यता आढळल्यास खाते आपोआप बंद होऊ शकते आणि कायदेशीर कारवाई केली जाऊ शकते."
          },
          security: {
            title: "२. ऑनलाइन बँकिंग आणि सुरक्षा",
            desc: "वापरकर्ते त्यांचे लॉगिन क्रेडेंशियल, पासवर्ड आणि मोबाईल ओटीपी (OTP) सुरक्षित ठेवण्यासाठी पूर्णपणे जबाबदार आहेत. तुमचा पासवर्ड कोणाशीही सामायिक करू नका. संग्राम पतसंस्था कधीही तुमचे पासवर्ड किंवा व्यवहारांचे पिन (PIN) विचारणार नाही."
          },
          transaction: {
            title: "३. व्यवहार आणि निधी धोरणे",
            desc: "सर्व ऑनलाइन निधी हस्तांतरण, कर्जाची परतफेड आणि आवर्ती ठेव देयके व्यवहार मर्यादा आणि वेळेच्या अधीन आहेत. व्यवहाराच्या अपयशाच्या प्रसंगी, परतावा प्रक्रिया आंतरबँक सलोखा (interbank reconciliation) कालावधीच्या अधीन असते."
          },
          availability: {
            title: "४. सेवा उपलब्धता आणि व्यत्यय",
            desc: "आम्ही आमचे डिजिटल बँकिंग प्लॅटफॉर्म २४/७ ऑनलाइन ठेवण्याचा प्रयत्न करत असलो तरी, नियोजित अद्यतने, सर्व्हर देखभाल किंवा आमच्या नियंत्रणाबाहेरील समस्यांमुळे सेवांमध्ये व्यत्यय येऊ शकतो. या काळात व्यवहाराच्या विलंबासाठी आम्ही जबाबदार नाही."
          },
          liability: {
            title: "५. दायित्वाची मर्यादा",
            desc: "आमच्या वेबसाइट सेवांचा वापर किंवा वापर करण्यास असमर्थतेमुळे उद्भवलेल्या कोणत्याही थेट, अप्रत्यक्ष, विशेष किंवा परिणामी नुकसानीसाठी संग्राम पतसंस्था कोणत्याही परिस्थितीत जबाबदार असणार नाही, ज्यामध्ये व्यवहारातील विलंब किंवा प्रणालीतील बिघाड समाविष्ट आहे."
          },
          amendments: {
            title: "६. अटींमधील सुधारणा",
            desc: "आम्ही या अटींमध्ये कोणत्याही वेळी सुधारणा, बदल किंवा भर घालण्याचा अधिकार राखून ठेवतो. कोणतेही बदल अद्ययावत केलेल्या पुनरावलोकन तारखेसह येथे प्रकाशित केले जातील. सुधारणांनंतर आमच्या सेवांचा निरंतर वापर म्हणजे तुम्ही अद्ययावत अटींचा स्वीकार केल्याचे दर्शवतो."
          }
        }
      },
      branchesPage: {
        pageTitle: "आमचे नेटवर्क",
        pageSubtitle: "सांगली जिल्ह्यातील १८ प्रमुख ठिकाणी आधुनिक सहकारी बँकिंग पायाभूत सुविधांसह सेवा प्रदान करत आहोत.",
        quickDirectory: "द्रुत निर्देशिका",
        branchesHeader: "प्रत्येक प्रमुख शहरातील शाखा",
        searchPlaceholder: "शाखेचे नाव, गाव, फोन नंबरने शोधा...",
        headOffice: "मुख्य कार्यालय",
        selected: "निवडलेले",
        callHeadOffice: "मुख्य कार्यालयाला फोन करा",
        compliantTitle: "सुसंगत आणि इलेक्ट्रॉनिक पद्धतीने जोडलेले",
        compliantDesc: "संग्राम पतसंस्थेची प्रत्येक गाव आणि शहर शाखा सुरक्षित डिजिटल सर्व्हरद्वारे जोडलेली आहे, ज्यामुळे त्वरित पैसे हस्तांतरण, सुरक्षित ठेव योजना आणि उपयुक्त ग्राहक सेवा मिळते.",
        noBranchesFound: "तुमच्या शोधाशी जुळणारी एकही बँक शाखा आढळली नाही.",
        branchList: {
          "head-office-palus": {
            city: "मुख्य कार्यालय, पलूस",
            name: "संग्राम पतसंस्था मुख्य कार्यालय",
            address: "संग्राम भवन, प्लॉट नं. १८७/१, दुसरा मजला, तासगाव कराड रोड, इंडस्ट्रियल इस्टेट, पलूस.",
            manager: "श्री. एस. आर. पाटील"
          },
          "audyogik-vasahat": {
            city: "औद्योगिक वसाहत",
            name: "औद्योगिक वसाहत शाखा",
            address: "संग्राम भवन, प्लॉट नं. १८७/१, दुसरा मजला, तासगाव कराड रोड, इंडस्ट्रियल इस्टेट, पलूस.",
            manager: "श्रीमती. एस. ए. पवार"
          },
          "sawantpur-vasahat": {
            city: "सावंतपूर वसाहत",
            name: "सावंतपूर विस्तार शाखा",
            address: "सत्यविजय बँके जवळ, सावंतपूर कॉलनी.",
            manager: "श्री. एम. ए. सावंत"
          },
          "yelavi": {
            city: "येळावी",
            name: "येळावी गाव शाखा",
            address: "सांगली जिल्हा मध्यवर्ती बँके जवळ, येळावी.",
            manager: "श्री. के. डी. पाटील"
          },
          "tasgaon": {
            city: "तासगाव",
            name: "तासगाव शहर शाखा",
            address: "जोशी गल्ली, आदित्य बंगला, तासगाव.",
            manager: "श्रीमती. पी. आर. जाधव"
          },
          "savalaj": {
            city: "सावळज",
            name: "सावळज बाजार शाखा",
            address: "निकम गल्ली, हंकारे बिल्डिंग, हॉटेल आशीर्वाद जवळ, सावळज.",
            manager: "श्री. एस. के. शिंदे"
          },
          "islampur": {
            city: "ईश्वरपूर",
            name: "ईश्वरपूर शहर शाखा",
            address: "जुना भाजी बाजार, ब्राह्मणपुरी, गोसावी हॉस्पिटल जवळ, ईश्वरपूर.",
            manager: "श्री. आर. जी. भोसले"
          },
          "shirala": {
            city: "शिराळा",
            name: "शिराळा व्हॅली शाखा",
            address: "लक्ष्मी चौक, नाथ रोड, मांगले रोड, शिराळा.",
            manager: "श्री. ए. बी. नाईक"
          },
          "andhali": {
            city: "आंधळी",
            name: "आंधळी ग्रामीण शाखा",
            address: "श्री छत्रपती शिवाजी महाराज चौक, आंधळी.",
            manager: "श्री. एस. वी. मोरे"
          },
          "kadegaon": {
            city: "कडेगाव",
            name: "कडेगाव तालुका शाखा",
            address: "कडेगाव तडसर रोड, मैत्रेय पार्क, कडेगाव.",
            manager: "श्री. व्ही. एम. पवार"
          },
          "vita": {
            city: "विटा",
            name: "विटा शहर शाखा",
            address: "मुक्तांगण वाचनालय, विटा कराड रोड जवळ, विटा.",
            manager: "श्री. एच. डी. देशमुख"
          },
          "bhilawadi": {
            city: "भिलवडी",
            name: "भिलवडी नदीकाठ शाखा",
            address: "आष्टा तासगाव रोड, भारती बाजार समोर, पहिला मजला, भिलवडी.",
            manager: "श्री. जी. एन. कुलकर्णी"
          },
          "sangli": {
            city: "सांगली",
            name: "सांगली शहर शाखा",
            address: "राम मंदिर, सिव्हिल हॉस्पिटल रोड, आदित्य साई लँडमार्क, गाळा नं. १.",
            manager: "श्री. एस. एस. गायकवाड"
          },
          "manerajuri": {
            city: "मणेराजुरी",
            name: "मणेराजुरी गाव शाखा",
            address: "एस. टी. स्टँड समोर, आय. सी. आय. सी. ए. टी. एम. च्या मागे, मणेराजुरी.",
            manager: "श्री. के. डी. माने"
          },
          "palus-shahar": {
            city: "पलूस शहर",
            name: "पलूस शहर शाखा",
            address: "नागोबा मंदिराजवळ, मुख्य रस्ता, पलूस.",
            manager: "श्री. पी. के. सुतार"
          },
          "takari": {
            city: "ताकारी",
            name: "ताकारी जंक्शन शाखा",
            address: "ग्रामपंचायती जवळ, मुख्य रस्ता, ताकारी.",
            manager: "श्री. डी. एस. सुतार"
          },
          "aalsand": {
            city: "आळसंद",
            name: "आळसंद डोंगरी शाखा",
            address: "लक्ष्मी मंदिराजवळ, मुख्य रस्ता, आळसंद.",
            manager: "श्री. व्ही. एस. साळुंखे"
          },
          "malwadi": {
            city: "माळवाडी",
            name: "माळवाडी ग्रामीण शाखा",
            address: "पाटील डेअरी जवळ, माळवाडी.",
            manager: "श्री. एस. व्ही. पाटील"
          }
        }
      }
    }
  }
};

const defaultLanguage = () => {
  const initialized = localStorage.getItem('sangram_lang_pref_initialized');
  if (!initialized) {
    localStorage.setItem('sangram_lang_pref_initialized', 'true');
    localStorage.setItem('i18nextLng', 'mr');
    return 'mr';
  }
  return localStorage.getItem('i18nextLng') || 'mr';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;
